import {
	ApiPayload,
	ApiResponse,
	Datetime2,
	FK,
	Member,
	Option,
	SK,
	Team,
	TeamMemberDetail,
} from "@recore-solutions/nstar-lib";
import { NstarType } from "src/app/shared/interfaces/types";

interface Listing {
	listingSK: SK<Listing> & number;
}

export const enum OpenHouseTypeName {
	Public = "Public",
	Broker = "Broker",
	VirtualPublic = "vPublic",
	VirtualBroker = "vBroker",
}

export const enum OpenHouseRefreshments {
	Drinks = "DRNK",
	Lunch = "LNCH",
	None = "NONE",
	Snacks = "SNKS",
}

export const OpenHouseRefreshmentOptions: Option[] = [
	{
		key: OpenHouseRefreshments.Drinks,
		value: "Drinks",
		sortOrder: 0,
	},
	{
		key: OpenHouseRefreshments.Lunch,
		value: "Lunch",
		sortOrder: 1,
	},
	{
		key: OpenHouseRefreshments.Snacks,
		value: "Snacks",
		sortOrder: 2,
	},
	{
		key: OpenHouseRefreshments.None,
		value: "None",
		sortOrder: 2,
	},
];

export interface OpenHouse extends NstarType {
	openHouseSK: SK<OpenHouse> & number;
	listingSK: FK<Listing>;
	teamMemberSK: FK<TeamMemberDetail>;
	readonly memberSK: FK<Member>;
	readonly memberFullName: string;
	readonly memberReference: string;
	readonly teamSK: FK<Team>;
	readonly teamName: string;
	typeName: OpenHouseTypeName;
	refreshments: OpenHouseRefreshments;
	refreshmentTypeCD?: OpenHouseRefreshments;
	comments: string;
	virtualURL: string;
	virtualURLNotes: string;
	seriesNbr: number;

	/** @deprecated use seriesStartDT instead */
	seriesStartDTTM: Datetime2;
	seriesStartDT: Datetime2;

	/** @deprecated use seriesEndDT instead */
	seriesEndDTTM: Datetime2;
	seriesEndDT: Datetime2;
	seriesDayOccurrence: string;
	startDTTM: Datetime2;
	endDTTM: Datetime2;
	deleteDTTM: Datetime2;
	singleMemberTeamIND: "Y" | "N";
}

export type OpenHouseApiResponse = ApiResponse<OpenHouse, [Datetime2]>;
export type OpenHouseApiPayload = ApiPayload<OpenHouse>;
